import { format } from 'date-fns';
import hoursToMinutes from 'date-fns/hoursToMinutes';

const cpf = (cpf: string) => {
  return `${cpf.substr(0, 3)}.${cpf.substr(3, 3)}.${cpf.substr(
    6,
    3
  )}-${cpf.substr(9, 2)}`;
};

// Format date to BR format
const birthdate = (date: Date) => {
  if (!date) {
    return '';
  }
  return format(new Date(date), 'dd/MM/yyyy');
};

// Format date back to ISO string format
const dateToISOString = (date: any) => {
  const dateParts = date.split('/');
  const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
  const dateResult = dateObject.toISOString();

  return dateResult;
};

// Format pet birthDate to get pet age
const petAge = (birthDate: any) => {
  const date = new Date();
  const yearDif = date.getFullYear() - birthDate.getFullYear();

  if (yearDif === 0) {
    const monthDif = date.getMonth() - birthDate.getMonth();
    if (monthDif === 0) {
      const dayDif = date.getDate() - birthDate.getDate();
      if (dayDif === 1) {
        return `${dayDif} dia`;
      }
      return `${dayDif} dias`;
    } else if (monthDif === 1) {
      return `${monthDif} mês`;
    } else {
      return `${monthDif} meses`;
    }
  } else if (yearDif === 1) {
    return `${yearDif} ano`;
  } else {
    return `${yearDif} anos`;
  }
};

// Format time to hour and minute
const timeToHourMinute = (time: any) => {
  const hour = Math.round(time);

  if (time > 1) {
    return `${hour}h${hoursToMinutes(time - hour)}min`;
  } else {
    return hoursToMinutes(time);
  }
};

/**
 * Remove line breaks \n or \n from string
 *
 * @param {string} text
 * @return {*}  {string}
 */
export const removeLineBreaks = (text: string): string => {
  if (typeof text !== 'string') {
    return '';
  }

  return text.replace(/[\r\n]/gm, '');
};

export const Format = {
  cpf,
  birthdate,
  dateToISOString,
  petAge,
  timeToHourMinute,
  removeLineBreaks,
};

